export type PropertyTypes =
  | 'Multifamily'
  | 'Mixed-use'
  | 'Commercial'
  | 'Industrial'
  | 'Office'
  | 'Community Facility'
  | 'Retail'
  | 'Mixed Use (Residential and Commercial)'
  | 'Residential (Non-Commercial)';

export enum TabType {
  ActiveReports = 0,
  CompletedReports = 1,
  AllReports = 2,
}
